import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { SimplebarAngularModule } from "simplebar-angular";
import { NgbDropdownModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { LayoutComponent } from "./layout.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { TopbarComponent } from "./topbar/topbar.component";
import { FooterComponent } from "./footer/footer.component";
import { RightsidebarComponent } from "./rightsidebar/rightsidebar.component";
import { HorizontalComponent } from "./horizontal/horizontal.component";
import { VerticalComponent } from "./vertical/vertical.component";
import { HorizontaltopbarComponent } from "./horizontaltopbar/horizontaltopbar.component";
import { LanguageService } from "../core/services/language.service";
import { TranslateModule } from "@ngx-translate/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ThemeToggleComponent } from "../shared/isolutions-ui/theme/theme-toggle/theme-toggle.component";
import { AutocompleteFieldComponent } from "../shared/isolutions-ui/forms/autocomplete-field/autocomplete-field.component";
import { ButtonComponent } from "../shared/isolutions-ui/layout/buttons/button/button.component";

@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [
    LayoutComponent,
    SidebarComponent,
    TopbarComponent,
    FooterComponent,
    RightsidebarComponent,
    HorizontalComponent,
    VerticalComponent,
    HorizontaltopbarComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    NgbDropdownModule,
    SimplebarAngularModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ThemeToggleComponent,
    AutocompleteFieldComponent,
    ButtonComponent,
  ],
  providers: [LanguageService],
})
export class LayoutsModule {}

